var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import Sticker from './Sticker';
var CordataButton = function CordataButton(_ref) {
  var type = _ref.type,
    color = _ref.color,
    children = _ref.children,
    icon = _ref.icon,
    hasActiveChild = _ref.hasActiveChild,
    isChild = _ref.isChild,
    outline = _ref.outline,
    spear = _ref.spear,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ['type', 'color', 'children', 'icon', 'hasActiveChild', 'isChild', 'outline', 'spear', 'className']);
  var c = color;
  var i = icon;
  var o = outline;
  var t = type;
  if (type === 'submit') {
    c = 'primary';
    i = 'save';
    t = 'submit';
  } else if (type === 'cancel') {
    c = 'tertiary';
    i = 'times';
    o = o === undefined ? true : o;
  }
  return spear ? React.createElement('div', {
    className: 'btn-spear'
  }, React.createElement(Button, _extends({
    type: t,
    color: c,
    outline: o,
    className: className
  }, props), React.createElement(Sticker, {
    icon: i
  }, children))) : React.createElement(Button, _extends({
    type: t,
    color: c,
    outline: o,
    className: className
  }, props), React.createElement(Sticker, {
    icon: i
  }, children));
};
CordataButton.propTypes = {
  type: PropTypes.oneOf(['button', 'cancel', 'reset', 'submit']),
  children: PropTypes.node.isRequired,
  icon: PropTypes.string,
  hasActiveChild: PropTypes.bool,
  isChild: PropTypes.bool,
  color: PropTypes.string,
  outline: PropTypes.bool,
  spear: PropTypes.bool,
  className: PropTypes.string
};
CordataButton.defaultProps = {
  type: 'button',
  icon: undefined,
  hasActiveChild: false,
  isChild: false,
  color: 'secondary',
  outline: undefined,
  spear: false,
  className: undefined
};
export default CordataButton;